export const prices=[
    {
        value: 16700
    },
    {
        value: 12500
    },
    {
        value: 8500
    },
    {
        value: 26600
    },
    {
        value: 34440
    },
    {
        value: 23363
    },
    {
        value: 159800
    },
    {
        value: 74600
    },
    {
        value: 63000
    },
    {
        value: 90000
    },
    {
        value: 52400
    },
    {
        value: 4500
    },
    {
        value: 55000
    },
    {
        value: 17280
    },
    {
        value: 16800
    },
    {
        value: 22500
    },
    {
        value: 40000
    },
    {
        value: 26000
    },
    {
        value: 105000
    },
    {
        value: 10000
    },
    {
        value: 35000
    },
    {
        value: 45000
    },
    {
        value: 135000
    },
    {
        value: 21000
    },
    {
        value: 30000
    },
    {
        value: 250000
    },
    {
        value: 23000
    },
    {
        value: 150000
    },
    {
        value: 285000
    },
    {
        value: 110000
    },
    {
        value: 23500
    },
    {
        value: 310000
    },
    {
        value: 21500
    },
    {
        value: 23426
    },
    {
        value: 17500
    },
    {
        value: 88000
    },
    {
        value: 16900
    },
    {
        value: 55300
    },
    {
        value: 48000
    },
    {
        value: 32000
    },
    {
        value: 175800
    },
    {
        value: 75000
    },
    {
        value: 29120
    },
    {
        value: 163800
    },
    {
        value: 27500
    },
    {
        value: 56500
    },
    {
        value: 24000
    },
    {
        value: 490000
    },
    {
        value: 29000
    },
    {
        value: 19500
    },
    {
        value: 62000
    },
    {
        value: 22000
    },
    {
        value: 23800
    },
    {
        value: 39500
    },
    {
        value: 11850
    },
    {
        value: 27000
    },
    {
        value: 97300
    },
    {
        value: 67000
    },
    {
        value: 70000
    },
    {
        value: 21300
    },
    {
        value: 14000
    },
    {
        value: 9773
    },
    {
        value: 120000
    },
    {
        value: 48500
    },
    {
        value: 14796
    },
    {
        value: 20500
    },
    {
        value: 16000
    },
    {
        value: 7135
    },
    {
        value: 12000
    },
    {
        value: 13700
    },
    {
        value: 14500
    },
    {
        value: 103000
    },
    {
        value: 19600
    },
    {
        value: 23930
    },
    {
        value: 41355
    },
    {
        value: 73000
    },
    {
        value: 90600
    },
    {
        value: 76800
    },
    {
        value: 34500
    },
    {
        value: 11000
    },
    {
        value: 395000
    },
    {
        value: 78500
    },
    {
        value: 65000
    },
    {
        value: 19900
    },
    {
        value: 36000
    },
    {
        value: 29500
    },
    {
        value: 272000
    },
    {
        value: 124000
    },
    {
        value: 11500
    },
    {
        value: 6160
    },
    {
        value: 15500
    },
    {
        value: 16250
    },
    {
        value: 20592
    },
    {
        value: 495000
    },
    {
        value: 19400
    },
    {
        value: 155000
    },
    {
        value: 148500
    },
    {
        value: 195000
    },
    {
        value: 82000
    },
    {
        value: 20162
    },
    {
        value: 99000
    },
    {
        value: 21866
    },
    {
        value: 59000
    },
    {
        value: 24300
    },
    {
        value: 356900
    },
    {
        value: 66000
    },
    {
        value: 7000
    },
    {
        value: 55575
    },
    {
        value: 41400
    },
    {
        value: 22550
    },
    {
        value: 63100
    },
    {
        value: 98000
    },
    {
        value: 15000
    },
    {
        value: 13500
    },
    {
        value: 47500
    },
    {
        value: 59500
    },
    {
        value: 43000
    },
    {
        value: 113844
    },
    {
        value: 76000
    },
    {
        value: 100000
    },
    {
        value: 10700
    },
    {
        value: 3950
    },
    {
        value: 85000
    },
    {
        value: 9000
    },
    {
        value: 50000
    },
    {
        value: 170000
    },
    {
        value: 64000
    },
    {
        value: 69000
    },
    {
        value: 18600
    },
    {
        value: 22100
    },
    {
        value: 104670
    },
    {
        value: 29146
    },
    {
        value: 2450
    },
    {
        value: 17808
    },
    {
        value: 16500
    },
    {
        value: 54000
    },
    {
        value: 46000
    },
    {
        value: 19300
    },
    {
        value: 18824
    },
    {
        value: 28000
    },
    {
        value: 14700
    },
    {
        value: 15550
    },
    {
        value: 9700
    },
    {
        value: 24500
    },
    {
        value: 79900
    },
    {
        value: 265000
    },
    {
        value: 60000
    },
    {
        value: 132000
    },
    {
        value: 124500
    },
    {
        value: 18500
    },
    {
        value: 390000
    },
    {
        value: 34000
    },
    {
        value: 94000
    },
    {
        value: 175000
    },
    {
        value: 200000
    },
    {
        value: 56400
    },
    {
        value: 52000
    },
    {
        value: 9620
    },
    {
        value: 38700
    },
    {
        value: 22600
    },
    {
        value: 160000
    },
    {
        value: 32760
    },
    {
        value: 58500
    },
    {
        value: 78000
    },
    {
        value: 3000
    },
    {
        value: 80000
    },
    {
        value: 49000
    },
    {
        value: 20000
    },
    {
        value: 25500
    },
    {
        value: 11300
    },
    {
        value: 43500
    },
    {
        value: 36250
    },
    {
        value: 21600
    },
    {
        value: 15840
    },
    {
        value: 10500
    },
    {
        value: 55845
    },
    {
        value: 38500
    },
    {
        value: 74000
    },
    {
        value: 11552
    },
    {
        value: 72000
    },
    {
        value: 7720
    },
    {
        value: 18300
    },
    {
        value: 11180
    },
    {
        value: 24900
    },
    {
        value: 145000
    },
    {
        value: 223000
    },
    {
        value: 18700
    },
    {
        value: 3045
    },
    {
        value: 33500
    },
    {
        value: 330000
    },
    {
        value: 56000
    },
    {
        value: 168000
    },
    {
        value: 126000
    },
    {
        value: 11600
    },
    {
        value: 7490
    },
    {
        value: 28500
    },
    {
        value: 320000
    },
    {
        value: 26505
    },
    {
        value: 24600
    },
    {
        value: 6090
    },
    {
        value: 72500
    },
    {
        value: 47700
    },
    {
        value: 167000
    },
    {
        value: 450000
    },
    {
        value: 113000
    },
    {
        value: 43400
    },
    {
        value: 1100
    },
    {
        value: 316000
    },
    {
        value: 37500
    },
    {
        value: 130000
    },
    {
        value: 38000
    },
    {
        value: 19459
    },
    {
        value: 37135
    },
    {
        value: 44000
    },
    {
        value: 25000
    },
    {
        value: 15900
    },
    {
        value: 19800
    },
    {
        value: 8700
    },
    {
        value: 42500
    },
    {
        value: 97000
    },
    {
        value: 185000
    },
    {
        value: 15950
    },
    {
        value: 18000
    },
    {
        value: 13000
    },
    {
        value: 19000
    },
    {
        value: 39000
    },
    {
        value: 26298
    },
    {
        value: 315000
    },
    {
        value: 76900
    },
    {
        value: 33000
    },
    {
        value: 20200
    },
    {
        value: 29900
    },
    {
        value: 11488
    },
    {
        value: 7500
    },
    {
        value: 20835
    },
    {
        value: 435000
    },
    {
        value: 14586
    },
    {
        value: 9600
    },
    {
        value: 17200
    },
    {
        value: 111433
    },
    {
        value: 255000
    },
    {
        value: 6500
    },
    {
        value: 17300
    },
    {
        value: 780000
    },
    {
        value: 37000
    },
    {
        value: 49500
    },
    {
        value: 17600
    },
    {
        value: 9500
    },
    {
        value: 11830
    },
    {
        value: 215000
    },
    {
        value: 46700
    },
    {
        value: 20615
    },
    {
        value: 96000
    },
    {
        value: 6000
    },
    {
        value: 39400
    },
    {
        value: 17900
    },
    {
        value: 39200
    },
    {
        value: 2600
    },
    {
        value: 95000
    },
    {
        value: 26082
    },
    {
        value: 115000
    },
    {
        value: 5500
    },
    {
        value: 23175
    },
    {
        value: 125000
    },
    {
        value: 137500
    },
    {
        value: 1700
    },
    {
        value: 10080
    },
    {
        value: 190000
    },
    {
        value: 12635
    },
    {
        value: 143000
    },
    {
        value: 46224
    },
    {
        value: 169000
    },
    {
        value: 14950
    },
    {
        value: 17350
    },
    {
        value: 23456
    },
    {
        value: 17760
    },
    {
        value: 22470
    },
    {
        value: 485000
    },
    {
        value: 187500
    },
    {
        value: 65500
    },
    {
        value: 16400
    },
    {
        value: 44500
    },
    {
        value: 68000
    },
    {
        value: 183000
    },
    {
        value: 220000
    },
    {
        value: 40527
    },
    {
        value: 145500
    },
    {
        value: 37300
    },
    {
        value: 53600
    },
    {
        value: 10215
    },
    {
        value: 44300
    },
    {
        value: 138000
    },
    {
        value: 47000
    },
    {
        value: 14200
    },
    {
        value: 29600
    },
    {
        value: 32500
    },
    {
        value: 810000
    },
    {
        value: 42000
    },
    {
        value: 15800
    },
    {
        value: 8000
    },
    {
        value: 108000
    },
    {
        value: 89000
    },
    {
        value: 160900
    },
    {
        value: 27200
    },
    {
        value: 19700
    },
    {
        value: 9296
    },
    {
        value: 31700
    },
    {
        value: 33700
    },
    {
        value: 24570
    },
    {
        value: 31000
    },
    {
        value: 99500
    },
    {
        value: 165000
    },
    {
        value: 26800
    },
    {
        value: 136500
    },
    {
        value: 101400
    },
    {
        value: 66500
    },
    {
        value: 13200
    },
    {
        value: 7400
    },
    {
        value: 14800
    },
    {
        value: 87795
    },
    {
        value: 275000
    },
    {
        value: 31900
    },
    {
        value: 14300
    },
    {
        value: 8900
    },
    {
        value: 13965
    },
    {
        value: 40200
    },
    {
        value: 128000
    },
    {
        value: 45350
    },
    {
        value: 360000
    },
    {
        value: 67400
    },
    {
        value: 34900
    },
    {
        value: 45900
    },
    {
        value: 50200
    },
    {
        value: 148000
    },
    {
        value: 18200
    },
    {
        value: 29785
    },
    {
        value: 56100
    },
    {
        value: 51300
    },
    {
        value: 5790
    },
    {
        value: 15300
    },
    {
        value: 240000
    },
    {
        value: 18171
    },
    {
        value: 21960
    },
    {
        value: 22816
    },
    {
        value: 15392
    },
    {
        value: 22700
    },
    {
        value: 260500
    },
    {
        value: 650000
    },
    {
        value: 43900
    },
    {
        value: 12236
    },
    {
        value: 122800
    },
    {
        value: 235000
    },
    {
        value: 53300
    },
    {
        value: 55500
    },
    {
        value: 17000
    },
    {
        value: 8788
    },
    {
        value: 353000
    },
    {
        value: 1640
    },
    {
        value: 263900
    },
    {
        value: 57500
    },
    {
        value: 53000
    },
    {
        value: 123000
    },
    {
        value: 33100
    },
    {
        value: 12700
    },
    {
        value: 51200
    },
    {
        value: 27405
    },
    {
        value: 24075
    },
    {
        value: 530000
    },
    {
        value: 13800
    },
    {
        value: 13050
    },
    {
        value: 153000
    },
    {
        value: 14665
    },
    {
        value: 22300
    },
    {
        value: 39555
    },
    {
        value: 78200
    },
    {
        value: 79500
    },
    {
        value: 85400
    },
    {
        value: 35500
    },
    {
        value: 26500
    },
    {
        value: 13600
    },
    {
        value: 16100
    },
    {
        value: 33888
    },
    {
        value: 35700
    },
    {
        value: 49200
    },
    {
        value: 41700
    },
    {
        value: 93000
    },
    {
        value: 37800
    },
    {
        value: 112000
    },
    {
        value: 225000
    },
    {
        value: 45500
    },
    {
        value: 25740
    },
    {
        value: 189000
    },
    {
        value: 25200
    },
    {
        value: 149000
    },
    {
        value: 9900
    },
    {
        value: 64620
    },
    {
        value: 81700
    },
    {
        value: 15232
    },
    {
        value: 47970
    },
    {
        value: 63360
    },
    {
        value: 13900
    },
    {
        value: 52600
    },
    {
        value: 19050
    },
    {
        value: 34110
    },
    {
        value: 50500
    },
    {
        value: 27600
    },
    {
        value: 36900
    },
    {
        value: 12150
    },
    {
        value: 21200
    },
    {
        value: 43100
    },
    {
        value: 28834
    },
    {
        value: 14168
    },
    {
        value: 91500
    },
    {
        value: 214300
    },
    {
        value: 59900
    },
    {
        value: 30015
    },
    {
        value: 42795
    },
    {
        value: 157000
    },
    {
        value: 106000
    },
    {
        value: 67500
    },
    {
        value: 4000
    },
    {
        value: 26145
    },
    {
        value: 92500
    },
    {
        value: 37100
    },
    {
        value: 49300
    },
    {
        value: 9750
    },
    {
        value: 12847
    },
    {
        value: 1240000
    },
    {
        value: 9802
    },
    {
        value: 86000
    },
    {
        value: 41800
    },
    {
        value: 1400000
    },
    {
        value: 28800
    },
    {
        value: 87000
    },
    {
        value: 25300
    },
    {
        value: 31725
    },
    {
        value: 51700
    },
    {
        value: 46500
    },
    {
        value: 13770
    },
    {
        value: 14612
    },
    {
        value: 13122
    },
    {
        value: 152800
    },
    {
        value: 51795
    },
    {
        value: 20700
    },
    {
        value: 16300
    },
    {
        value: 139000
    },
    {
        value: 64500
    },
    {
        value: 24700
    },
    {
        value: 106500
    },
    {
        value: 9800
    },
    {
        value: 77000
    },
    {
        value: 1590
    },
    {
        value: 8100
    },
    {
        value: 38940
    },
    {
        value: 17400
    },
    {
        value: 25800
    },
    {
        value: 36100
    },
    {
        value: 295000
    },
    {
        value: 62500
    },
    {
        value: 12750
    },
    {
        value: 5600
    },
    {
        value: 29385
    },
    {
        value: 10200
    },
    {
        value: 25350
    },
    {
        value: 47900
    },
    {
        value: 19786
    },
    {
        value: 11616
    },
    {
        value: 9300
    },
    {
        value: 580000
    },
    {
        value: 8800
    },
    {
        value: 31500
    },
    {
        value: 54630
    },
    {
        value: 58000
    },
    {
        value: 458500
    },
    {
        value: 35630
    },
    {
        value: 259250
    },
    {
        value: 45810
    },
    {
        value: 2000
    },
    {
        value: 14600
    },
    {
        value: 113850
    },
    {
        value: 24660
    },
    {
        value: 31200
    },
    {
        value: 138900
    },
    {
        value: 16713
    },
    {
        value: 2900
    },
    {
        value: 27300
    },
    {
        value: 12355
    },
    {
        value: 22860
    },
    {
        value: 169800
    },
    {
        value: 290000
    },
    {
        value: 20195
    },
    {
        value: 44200
    },
    {
        value: 12250
    },
    {
        value: 91000
    },
    {
        value: 858000
    },
    {
        value: 10800
    },
    {
        value: 6422
    },
    {
        value: 3400
    },
    {
        value: 5880
    },
    {
        value: 37400
    },
    {
        value: 17100
    },
    {
        value: 198500
    },
    {
        value: 50700
    },
    {
        value: 19350
    },
    {
        value: 14420
    },
    {
        value: 22635
    },
    {
        value: 22050
    },
    {
        value: 2500
    },
    {
        value: 208965
    },
    {
        value: 41000
    },
    {
        value: 423529
    },
    {
        value: 80700
    },
    {
        value: 90675
    },
    {
        value: 30400
    },
    {
        value: 5800
    },
    {
        value: 102000
    },
    {
        value: 2970
    },
    {
        value: 11778
    },
    {
        value: 61000
    },
    {
        value: 37200
    },
    {
        value: 76400
    },
    {
        value: 1388900
    },
    {
        value: 157500
    },
    {
        value: 140600
    },
    {
        value: 108234
    },
    {
        value: 9152
    },
    {
        value: 181000
    },
    {
        value: 385000
    },
    {
        value: 28400
    },
    {
        value: 57000
    },
    {
        value: 69800
    },
    {
        value: 302500
    },
    {
        value: 25785
    },
    {
        value: 26705
    },
    {
        value: 77500
    },
    {
        value: 26900
    },
    {
        value: 1100000
    },
    {
        value: 33900
    },
    {
        value: 10900
    },
    {
        value: 393000
    },
    {
        value: 280000
    },
    {
        value: 64300
    },
    {
        value: 36500
    },
    {
        value: 20748
    },
    {
        value: 29470
    },
    {
        value: 22200
    },
    {
        value: 248000
    },
    {
        value: 13132
    },
    {
        value: 26862
    },
    {
        value: 180000
    },
    {
        value: 26300
    },
    {
        value: 156000
    },
    {
        value: 54400
    },
    {
        value: 33400
    },
    {
        value: 15471
    },
    {
        value: 31460
    },
    {
        value: 12390
    },
    {
        value: 154500
    },
    {
        value: 40460
    },
    {
        value: 93700
    },
    {
        value: 62335
    },
    {
        value: 2370
    },
    {
        value: 46358
    },
    {
        value: 300000
    },
    {
        value: 15158
    },
    {
        value: 76500
    },
    {
        value: 19915
    },
    {
        value: 87500
    },
    {
        value: 24922
    },
    {
        value: 32300
    },
    {
        value: 118500
    },
    {
        value: 28938
    },
    {
        value: 325000
    },
    {
        value: 13100
    },
    {
        value: 31800
    },
    {
        value: 99090
    },
    {
        value: 9275
    },
    {
        value: 89730
    },
    {
        value: 12555
    },
    {
        value: 18800
    },
    {
        value: 12124
    },
    {
        value: 7700
    },
    {
        value: 84000
    },
    {
        value: 117000
    },
    {
        value: 17037
    },
    {
        value: 83350
    },
    {
        value: 10730
    },
    {
        value: 750000
    },
    {
        value: 16940
    },
    {
        value: 5000
    },
    {
        value: 74700
    },
    {
        value: 420000
    },
    {
        value: 2190
    },
    {
        value: 23900
    },
    {
        value: 34155
    },
    {
        value: 70750
    },
    {
        value: 30420
    },
    {
        value: 386000
    },
    {
        value: 30690
    },
    {
        value: 23600
    },
    {
        value: 15810
    },
    {
        value: 187000
    },
    {
        value: 850000
    },
    {
        value: 81600
    },
    {
        value: 40300
    },
    {
        value: 79000
    },
    {
        value: 12450
    },
    {
        value: 97500
    },
    {
        value: 4077
    },
    {
        value: 15540
    },
    {
        value: 40590
    },
    {
        value: 385386
    },
    {
        value: 32700
    },
    {
        value: 27800
    },
    {
        value: 83400
    },
    {
        value: 36400
    },
    {
        value: 52500
    },
    {
        value: 11800
    },
    {
        value: 210000
    },
    {
        value: 21800
    },
    {
        value: 6800
    },
    {
        value: 35800
    },
    {
        value: 16562
    },
    {
        value: 28600
    },
    {
        value: 10894
    },
    {
        value: 167600
    },
    {
        value: 82500
    },
    {
        value: 27400
    },
    {
        value: 21700
    },
    {
        value: 81000
    },
    {
        value: 18112
    },
    {
        value: 102735
    },
    {
        value: 23136
    },
    {
        value: 17225
    },
    {
        value: 2400
    },
    {
        value: 71435
    },
    {
        value: 21384
    },
    {
        value: 19200
    },
    {
        value: 10590
    },
    {
        value: 11700
    },
    {
        value: 10220
    },
    {
        value: 10400
    },
    {
        value: 10980
    },
    {
        value: 34470
    },
    {
        value: 25900
    },
    {
        value: 78570
    },
    {
        value: 25515
    },
    {
        value: 68940
    },
    {
        value: 24111
    },
    {
        value: 71500
    },
    {
        value: 85500
    },
    {
        value: 140000
    },
    {
        value: 193500
    },
    {
        value: 17910
    },
    {
        value: 15100
    },
    {
        value: 45700
    },
    {
        value: 39100
    },
    {
        value: 1075000
    },
    {
        value: 111600
    },
    {
        value: 15200
    },
    {
        value: 7900
    },
    {
        value: 10300
    },
    {
        value: 50400
    },
    {
        value: 45270
    },
    {
        value: 19560
    },
    {
        value: 31600
    },
    {
        value: 13125
    },
    {
        value: 37341
    },
    {
        value: 20600
    },
    {
        value: 19110
    },
    {
        value: 21681
    },
    {
        value: 22958
    },
    {
        value: 640000
    },
    {
        value: 36300
    },
    {
        value: 9184
    },
    {
        value: 92000
    },
    {
        value: 66900
    },
    {
        value: 24732
    },
    {
        value: 94200
    },
    {
        value: 47300
    },
    {
        value: 53500
    },
    {
        value: 17415
    },
    {
        value: 30100
    },
    {
        value: 262000
    },
    {
        value: 21100
    },
    {
        value: 2350000
    },
    {
        value: 35100
    },
    {
        value: 8155
    },
    {
        value: 16785
    },
    {
        value: 465000
    },
    {
        value: 77400
    },
    {
        value: 27866
    },
    {
        value: 43290
    },
    {
        value: 7105
    },
    {
        value: 20755
    },
    {
        value: 10600
    },
    {
        value: 34380
    },
    {
        value: 12900
    },
    {
        value: 120840
    },
    {
        value: 76600
    },
    {
        value: 25056
    },
    {
        value: 142400
    },
    {
        value: 10650
    },
    {
        value: 19485
    },
    {
        value: 305000
    },
    {
        value: 75300
    },
    {
        value: 26325
    },
    {
        value: 17550
    },
    {
        value: 13850
    },
    {
        value: 60570
    },
    {
        value: 19864
    },
    {
        value: 52800
    },
    {
        value: 113500
    },
    {
        value: 34450
    },
    {
        value: 89500
    },
    {
        value: 21900
    },
    {
        value: 100004
    },
    {
        value: 365000
    },
    {
        value: 116100
    },
    {
        value: 64800
    },
    {
        value: 50950
    },
    {
        value: 980000
    },
    {
        value: 306000
    },
    {
        value: 50350
    },
    {
        value: 12565
    },
    {
        value: 4200
    },
    {
        value: 43740
    },
    {
        value: 350000
    },
    {
        value: 12300
    },
    {
        value: 7341
    },
    {
        value: 75500
    },
    {
        value: 17950
    },
    {
        value: 13473
    },
    {
        value: 41500
    },
    {
        value: 63315
    },
    {
        value: 23300
    },
    {
        value: 15400
    },
    {
        value: 11804
    },
    {
        value: 146000
    },
    {
        value: 60300
    },
    {
        value: 33750
    },
    {
        value: 400000
    },
    {
        value: 34950
    },
    {
        value: 358000
    },
    {
        value: 13650
    },
    {
        value: 5535
    },
    {
        value: 31635
    },
    {
        value: 27440
    },
    {
        value: 63500
    },
    {
        value: 17700
    },
    {
        value: 13412
    },
    {
        value: 61600
    },
    {
        value: 45800
    },
    {
        value: 62700
    },
    {
        value: 37466
    },
    {
        value: 20250
    },
    {
        value: 214294
    },
    {
        value: 35200
    },
    {
        value: 13250
    },
    {
        value: 30240
    },
    {
        value: 1600
    },
    {
        value: 253000
    },
    {
        value: 5236
    },
    {
        value: 80640
    },
    {
        value: 158500
    },
    {
        value: 5200
    },
    {
        value: 46600
    },
    {
        value: 12220
    },
    {
        value: 4600
    },
    {
        value: 20300
    },
    {
        value: 7300
    },
    {
        value: 7800
    },
    {
        value: 275800
    },
    {
        value: 28053
    },
    {
        value: 18400
    },
    {
        value: 30700
    },
    {
        value: 9400
    },
    {
        value: 33800
    },
    {
        value: 72200
    },
    {
        value: 35900
    },
    {
        value: 28782
    },
    {
        value: 20070
    },
    {
        value: 15925
    },
    {
        value: 17800
    },
    {
        value: 370000
    },
    {
        value: 180550
    },
    {
        value: 1620
    },
    {
        value: 31300
    },
    {
        value: 46722
    },
    {
        value: 46200
    },
    {
        value: 116000
    },
    {
        value: 5635
    },
    {
        value: 80600
    },
    {
        value: 24800
    },
    {
        value: 69930
    },
    {
        value: 81300
    },
    {
        value: 51402
    },
    {
        value: 48700
    },
    {
        value: 51000
    },
    {
        value: 2870
    },
    {
        value: 7174
    },
    {
        value: 13400
    },
    {
        value: 8960
    },
    {
        value: 26182
    },
    {
        value: 7595
    },
    {
        value: 17155
    },
    {
        value: 35600
    },
    {
        value: 35464
    },
    {
        value: 14900
    },
    {
        value: 228000
    },
    {
        value: 27900
    },
    {
        value: 38600
    },
    {
        value: 26320
    },
    {
        value: 14250
    },
    {
        value: 34200
    },
    {
        value: 345000
    },
    {
        value: 94500
    },
    {
        value: 69600
    },
    {
        value: 13188
    },
    {
        value: 13026
    },
    {
        value: 24760
    },
    {
        value: 347230
    },
    {
        value: 37550
    },
    {
        value: 69450
    },
    {
        value: 9315
    },
    {
        value: 21150
    },
    {
        value: 48105
    },
    {
        value: 16200
    },
    {
        value: 89900
    },
    {
        value: 11520
    },
    {
        value: 70500
    },
    {
        value: 47788
    },
    {
        value: 86700
    },
    {
        value: 15600
    },
    {
        value: 30500
    },
    {
        value: 43750
    },
    {
        value: 199000
    },
    {
        value: 520000
    },
    {
        value: 23556
    },
    {
        value: 17238
    },
    {
        value: 31905
    },
    {
        value: 125500
    },
    {
        value: 11336
    },
    {
        value: 3650
    },
    {
        value: 109300
    },
    {
        value: 182000
    },
    {
        value: 35910
    },
    {
        value: 65475
    },
    {
        value: 4300
    },
    {
        value: 7852
    },
    {
        value: 38100
    },
    {
        value: 32600
    },
    {
        value: 56835
    },
    {
        value: 550000
    },
    {
        value: 14233
    },
    {
        value: 288000
    },
    {
        value: 10720
    },
    {
        value: 64575
    },
    {
        value: 486115
    },
    {
        value: 3255
    },
    {
        value: 460000
    },
    {
        value: 37575
    },
    {
        value: 25272
    },
    {
        value: 12714
    },
    {
        value: 144750
    },
    {
        value: 710000
    },
    {
        value: 24705
    },
    {
        value: 33635
    },
    {
        value: 1900
    },
    {
        value: 13750
    },
    {
        value: 16120
    },
    {
        value: 7600
    },
    {
        value: 15700
    },
    {
        value: 8265
    },
    {
        value: 29050
    }
]
